import { Input, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Core, DisplayService, LabelNames } from '../core/ovs.core';
import { DisplayOptionsService } from '../../services/display-options.service';

@Component({
  selector: 'earn-reward-badge',
  templateUrl: './earn-reward-badge.component.html',
  styleUrls: ['./earn-reward-badge.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EarnRewardBadgeComponent implements OnInit {
  
  @Input() isStacked : boolean;

  @Input() earnFontSize : number;
  @Input() actionLabel: string = '[actionLabel]'
  @Input() earnLabelTwo : string = 'with this stay';
  @Input() earnValue : number;
  @Input() purchaseType : string = 'Ocean Points';
  @Input() perStayLabel : string = 'avg/night';
  @Input() nights: number = 0;
  @Input() showPerDay: boolean;

  public get rewardLabel(): string{
    return this.showPerDay ? "avg/night":"per stay";
  }

   
  public get rewardTypeLabel(): string{
    return this.displayOptions.getLabel(LabelNames.VacationCash);
  }


  public get rewardValue(): number{
    if( this.showPerDay && !isNaN(this.nights) && this.nights !=0 ){
      return Math.round(this.earnValue/this.nights);
    }
    return Math.round(this.earnValue);
  }

  constructor(private displayOptions: DisplayOptionsService) { }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/earn-reward-badge/earn-reward-badge.component.ts